import script from "./QuestionSlide007.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionSlide007.vue?vue&type=script&setup=true&lang=js"

import "./QuestionSlide007.vue?vue&type=style&index=0&id=0ea0037c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ea0037c"]])

export default __exports__